import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { ThemeSwitcher } from "@/components/ui/theme-switcher";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Pages
import Home from "./pages/Home";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import IssueDetails from "./pages/IssueDetails";
import ContactUs from "./pages/ContactUs";
import ErrorPage from "./pages/ErrorPage";
import { useEffect } from "react";

const queryClient = new QueryClient();

const App = () => {
  useEffect(() => {
    const applyTheme = () => {
      const root = document.documentElement;
      root.setAttribute("data-theme", "forest");
    };
    applyTheme();
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            className: "bg-background text-foreground border-border",
            duration: 5000, // 5 seconds
          }}
          expand={false}
        />
        {/* <ThemeSwitcher /> */}
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Login />} />
            <Route path="/home" element={<Home />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/issues/:id" element={<IssueDetails />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
